interface ShareConfig {
  url: string;
  title: string;
  text: string;
}

export const useShare = (config: ShareConfig, onSuccess?: () => void, onError?: () => void) => {
  const canShare = !!navigator.share;

  const showShareSheet = async () => {
    if (canShare) {
      try {
        await navigator.share(config);
        if (onSuccess) onSuccess();
      } catch (e) {
        if (onError) onError();
      }
    }
  };

  return { canShare, showShareSheet };
};
